<template>
  <p class="ui-game__score" v-text="score"></p>
</template>
<script setup>
import { computed } from 'vue';
import { store } from '@/components/ui-game/store';

const score = computed(() => store.state.score);
</script>
